import type { Distance, Margins } from "@pdfking/math"

import type { JobSchema } from "#internal"

const margins_empty = (margins: Margins<Distance>): boolean =>
  !margins.top && !margins.right && !margins.bottom && !margins.left

/** Python `_remove_jobs` (concrete.py:128-145). */
export const remove_redundant_jobs = (jobs: JobSchema[]): JobSchema[] => {
  const result: JobSchema[] = []
  let prev: JobSchema | undefined
  for (const job of jobs) {
    if (
      prev &&
      job.print_mode.id === prev.print_mode.id &&
      job.machine_size.width === prev.machine_size.width &&
      job.machine_size.height === prev.machine_size.height &&
      job.job_destination === prev.job_destination &&
      margins_empty(job.margins)
    ) {
      prev = job
      continue
    }
    result.push(job)
    prev = job
  }
  return result
}
